// Normalize input string

import type StateCore from '../state-core'

// https://spec.commonmark.org/0.29/#line-ending
const NEWLINES_RE = /\r\n?|\n/g
// oxlint-disable-next-line no-control-regex -- intentional: normalize NULL chars per CommonMark spec
const NULL_RE = /\u0000/g

export default function normalize(state: StateCore) {
  let str: string

  // Normalize newlines
  str = state.src.replace(NEWLINES_RE, '\n')

  // Replace NULL characters
  str = str.replace(NULL_RE, '\uFFFD')

  state.src = str
}
